import { useTranslation } from 'react-i18next';
import { howWeWorkSteps } from '@/mocks/landingData';

export default function HowWeWorkSection() {
  const { t } = useTranslation();

  return (
    <section id="howwework" className="relative w-full py-20 md:py-32 bg-dark-900">
      <div className="w-full px-4 md:px-6 lg:px-12">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white">
            {t('howWeWork.title1')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-blue to-neon-purple">
              {t('howWeWork.title2')}
            </span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-gray-400 max-w-xl mx-auto">
            {t('howWeWork.subtitle')}
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-0.5 bg-dark-300 hidden sm:block -translate-x-1/2" />

          <div className="space-y-8 md:space-y-12">
            {howWeWorkSteps.map((step, index) => (
              <div
                key={step.id}
                className="relative flex gap-4 md:gap-8 items-start group"
              >
                <div className="hidden sm:flex flex-col items-center z-10">
                  <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-dark-500 border border-dark-300 group-hover:border-neon-blue/50 group-hover:bg-neon-blue/10 flex items-center justify-center transition-all duration-500">
                    <span className="text-xs md:text-sm font-bold text-neon-blue">{index + 1}</span>
                  </div>
                  {index < howWeWorkSteps.length - 1 && (
                    <div className="w-0.5 h-12 md:h-16 bg-dark-300 mt-1" />
                  )}
                </div>

                <div className="flex-1 p-5 md:p-6 rounded-2xl bg-dark-500 border border-white/5 hover:border-neon-blue/20 transition-all duration-500 group-hover:translate-x-1">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-8 h-8 rounded-lg bg-dark-400 flex items-center justify-center sm:hidden">
                      <span className="text-xs font-bold text-neon-blue">{index + 1}</span>
                    </div>
                    <i className={`${step.icon} text-neon-blue text-lg md:text-xl`} />
                    <h3 className="text-base md:text-lg font-display font-bold text-white">
                      {t(`howWeWork.step${step.id}_title`)}
                    </h3>
                  </div>
                  <p className="text-xs md:text-sm text-gray-400 leading-relaxed">
                    {t(`howWeWork.step${step.id}_desc`)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
